import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  class: "file-upload-wrap"
};
const _hoisted_2 = ["multiple", "accept"];
const _hoisted_3 = {
  class: "file-upload-tip"
};
const _hoisted_4 = {
  key: 1,
  class: "file-upload-list"
};
const _hoisted_5 = {
  class: "file-upload-main"
};
const _hoisted_6 = {
  class: "file-upload-row"
};
const _hoisted_7 = ["title"];
const _hoisted_8 = {
  key: 0,
  class: "file-upload-size"
};
const _hoisted_9 = {
  key: 0,
  class: "file-upload-progress"
};
const _hoisted_10 = {
  class: "progress-bar"
};
const _hoisted_11 = {
  class: "progress-text"
};
const _hoisted_12 = {
  key: 1,
  class: "file-upload-error"
};
const _hoisted_13 = ["onClick"];
const _hoisted_14 = {
  key: 2,
  class: "file-upload-meta"
};
const _hoisted_15 = ["onClick"];
import { computed, ref } from 'vue';
import { ElMessage } from 'element-plus';
import FileIcon from './FileIcon.vue';
import { uploadFile } from '@/api/file';
import { getFileName, getFileSize } from '@/utils/fileType';
import { isPreviewableAttachmentFile } from '@/utils/fileAccept';
export default {
  __name: 'FileUpload',
  props: {
    files: {
      type: Array,
      default: () => []
    },
    accept: {
      type: String,
      default: ''
    },
    maxCount: {
      type: Number,
      default: 5
    },
    maxSize: {
      type: Number,
      default: 10
    },
    // 上传目录（业务模块），默认 'workflow'
    module: {
      type: String,
      default: 'workflow'
    },
    bucket: {
      type: String,
      default: 'private'
    }
  },
  emits: ['update:files', 'uploading-change'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const inputRef = ref(null);
    const isDragover = ref(false);
    // 上传中的临时项（uid -> item），与已完成 files 分开管理
    const uploadingItems = ref([]);
    const progressMap = ref({});
    const reachLimit = computed(() => props.files.length + uploadingItems.value.length >= props.maxCount);
    const acceptLabel = computed(() => {
      if (!props.accept) return '';
      return props.accept.split(',').map(s => s.trim().replace(/^\./, '').replace(/\/\*$/, '')).join('、').toUpperCase();
    });
    const renderList = computed(() => {
      const done = props.files.map((file, index) => {
        const uid = file.uid || file.fileKey || `done-${index}`;
        return {
          uid,
          name: getFileName(file),
          sizeText: getFileSize(file),
          status: 'success',
          progress: 100,
          raw: file,
          isFile: true
        };
      });
      const uploading = uploadingItems.value.map(item => ({
        uid: item.uid,
        name: item.name,
        sizeText: item.sizeText,
        status: item.status,
        progress: progressMap.value[item.uid] || 0,
        raw: item.raw,
        isFile: false
      }));
      return [...done, ...uploading];
    });
    function triggerPick() {
      if (reachLimit.value) {
        ElMessage.warning(`最多上传 ${props.maxCount} 个文件`);
        return;
      }
      inputRef.value?.click();
    }
    function onInputChange(e) {
      const files = Array.from(e.target.files || []);
      handleFiles(files);
      e.target.value = '';
    }
    function onDrop(e) {
      isDragover.value = false;
      if (reachLimit.value) {
        ElMessage.warning(`最多上传 ${props.maxCount} 个文件`);
        return;
      }
      const files = Array.from(e.dataTransfer?.files || []);
      handleFiles(files);
    }
    function handleFiles(files) {
      files.forEach(file => {
        if (props.files.length + uploadingItems.value.length >= props.maxCount) {
          ElMessage.warning(`最多上传 ${props.maxCount} 个文件`);
          return;
        }
        if (!isAccepted(file)) {
          ElMessage.warning(`${file.name} 不符合允许的文件类型`);
          return;
        }
        if (file.size > props.maxSize * 1024 * 1024) {
          ElMessage.warning(`${file.name} 不能超过 ${props.maxSize}MB`);
          return;
        }
        startUpload(file);
      });
    }
    function isAccepted(file) {
      return isPreviewableAttachmentFile(file, props.accept);
    }
    async function startUpload(rawFile) {
      const uid = `up-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
      const item = {
        uid,
        name: rawFile.name,
        sizeText: getFileSize({
          size: rawFile.size
        }),
        status: 'uploading',
        raw: rawFile
      };
      uploadingItems.value.push(item);
      progressMap.value[uid] = 0;
      emitUploading(true);

      // 模拟进度（el-upload 无 onProgress 时也用此策略）
      const fakeTimer = setInterval(() => {
        const cur = progressMap.value[uid] || 0;
        if (cur < 90) {
          progressMap.value[uid] = Math.min(90, cur + Math.random() * 15);
        }
      }, 300);
      try {
        const uploadResult = await uploadFile(rawFile, props.module, props.bucket);
        const data = uploadResult?.data || uploadResult || {};
        const fileKey = data.fileName || data.fileKey || data.key;
        if (!fileKey) throw new Error('上传结果缺少文件 Key');
        const uploaded = {
          uid,
          name: rawFile.name,
          fileName: rawFile.name,
          originalName: data.originalName || rawFile.name,
          fileKey,
          bucket: data.bucket || props.bucket,
          size: rawFile.size,
          fileSize: rawFile.size,
          contentType: rawFile.type,
          url: data.url
        };
        progressMap.value[uid] = 100;
        emit('update:files', [...props.files, uploaded]);

        // 移除上传中项
        uploadingItems.value = uploadingItems.value.filter(i => i.uid !== uid);
        if (!uploadingItems.value.length) emitUploading(false);
      } catch (err) {
        const target = uploadingItems.value.find(i => i.uid === uid);
        if (target) target.status = 'error';
        ElMessage.error(err?.message || '附件上传失败');
      } finally {
        clearInterval(fakeTimer);
      }
    }
    async function retryUpload(item) {
      // 找到原始 file 对象（浏览器 File 缓存在 raw 字段）
      const raw = item.raw;
      if (!raw) {
        ElMessage.warning('请重新选择文件');
        uploadingItems.value = uploadingItems.value.filter(i => i.uid !== item.uid);
        return;
      }
      uploadingItems.value = uploadingItems.value.filter(i => i.uid !== item.uid);
      startUpload(raw);
    }
    function removeItem(item) {
      if (item.status === 'success' && item.isFile) {
        // 已完成：从 files 中移除
        const next = props.files.filter((_, idx) => {
          const uid = props.files[idx].uid || props.files[idx].fileKey || `done-${idx}`;
          return uid !== item.uid;
        });
        emit('update:files', next);
      } else {
        // 上传中 / 失败：从 uploadingItems 中移除
        uploadingItems.value = uploadingItems.value.filter(i => i.uid !== item.uid);
        if (!uploadingItems.value.length) emitUploading(false);
      }
    }
    let uploadingEmitted = false;
    function emitUploading(v) {
      if (uploadingEmitted === v) return;
      uploadingEmitted = v;
      emit('uploading-change', v);
    }
    __expose({
      // 当前是否正在上传
      isUploading: () => uploadingItems.value.length > 0
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [!reachLimit.value ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["file-upload-trigger", {
          'is-dragover': isDragover.value
        }]),
        onClick: triggerPick,
        onDrop: _withModifiers(onDrop, ["prevent"]),
        onDragover: _cache[0] || (_cache[0] = _withModifiers($event => isDragover.value = true, ["prevent"])),
        onDragleave: _cache[1] || (_cache[1] = _withModifiers($event => isDragover.value = false, ["prevent"]))
      }, [_createElementVNode("input", {
        ref_key: "inputRef",
        ref: inputRef,
        type: "file",
        class: "hidden",
        multiple: __props.maxCount > 1,
        accept: __props.accept || undefined,
        onChange: onInputChange
      }, null, 40, _hoisted_2), _cache[2] || (_cache[2] = _createElementVNode("svg", {
        class: "file-upload-icon",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "1.6",
        d: "M7 16a4 4 0 01.88-7.903A5 5 0 1116.9 6L17 6a5 5 0 011 9.9M12 12v9m0-9l-3 3m3-3l3 3"
      })], -1)), _cache[3] || (_cache[3] = _createElementVNode("div", {
        class: "file-upload-text"
      }, "点击或拖拽文件上传", -1)), _createElementVNode("div", _hoisted_3, " 最多 " + _toDisplayString(__props.maxCount) + " 个，单个不超过 " + _toDisplayString(__props.maxSize) + "MB" + _toDisplayString(__props.accept ? `，仅支持 ${acceptLabel.value}` : ''), 1)], 34)) : _createCommentVNode("", true), renderList.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(renderList.value, item => {
        return _openBlock(), _createElementBlock("div", {
          key: item.uid,
          class: "file-upload-item"
        }, [_createVNode(FileIcon, {
          file: item,
          thumb: item.status === 'success',
          class: "w-9 h-9 shrink-0"
        }, null, 8, ["file", "thumb"]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("span", {
          class: "file-upload-name",
          title: item.name
        }, _toDisplayString(item.name), 9, _hoisted_7), item.sizeText ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(item.sizeText), 1)) : _createCommentVNode("", true)]), item.status === 'uploading' ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", {
          class: "progress-inner",
          style: _normalizeStyle({
            width: item.progress + '%'
          })
        }, null, 4)]), _createElementVNode("span", _hoisted_11, _toDisplayString(item.progress) + "%", 1)])) : item.status === 'error' ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_cache[4] || (_cache[4] = _createElementVNode("span", null, "上传失败", -1)), _createElementVNode("button", {
          type: "button",
          class: "retry-btn",
          onClick: _withModifiers($event => retryUpload(item), ["stop"])
        }, "重试", 8, _hoisted_13)])) : item.status === 'success' ? (_openBlock(), _createElementBlock("div", _hoisted_14, [...(_cache[5] || (_cache[5] = [_createElementVNode("svg", {
          class: "w-3 h-3 text-green-500",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "3",
          d: "M5 13l4 4L19 7"
        })], -1), _createElementVNode("span", null, "已上传", -1)]))])) : _createCommentVNode("", true)]), _createElementVNode("button", {
          type: "button",
          class: "file-upload-remove",
          title: "移除",
          onClick: _withModifiers($event => removeItem(item), ["stop"])
        }, [...(_cache[6] || (_cache[6] = [_createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M6 18L18 6M6 6l12 12"
        })], -1)]))], 8, _hoisted_15)]);
      }), 128))])) : _createCommentVNode("", true)]);
    };
  }
};